/**
 * @generated SignedSource<<612787c02336052e32a960b762284d9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PointsAdditionsTable_Query$variables = {
  filterByPointsPoolId?: string | null | undefined;
  filterByUserId?: string | null | undefined;
  first?: number | null | undefined;
};
export type PointsAdditionsTable_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PointsAdditionsTable_QueryFragment">;
};
export type PointsAdditionsTable_Query = {
  response: PointsAdditionsTable_Query$data;
  variables: PointsAdditionsTable_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByPointsPoolId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByUserId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filterByPointsPoolId",
    "variableName": "filterByPointsPoolId"
  },
  {
    "kind": "Variable",
    "name": "filterByUserId",
    "variableName": "filterByUserId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PointsAdditionsTable_Query",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "PointsAdditionsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PointsAdditionsTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PointsV2AdminSchema",
            "kind": "LinkedField",
            "name": "PointsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "PointsAdditionsV2Connection",
                "kind": "LinkedField",
                "name": "GetFilteredPointsAdditions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PointsAdditionsV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PointsAdditionV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentSubmission",
                            "kind": "LinkedField",
                            "name": "contentSubmission",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LearnOpportunityV2",
                                "kind": "LinkedField",
                                "name": "learnOpportunity",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "structureDefinition",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PointPool",
                            "kind": "LinkedField",
                            "name": "pointsPool",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "receivedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userExtensionKind",
                                    "value": "InfectopharmUserExtension"
                                  }
                                ],
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lastName",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "salutation",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "InfectopharmUserExtension",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": [
                  "filterByPointsPoolId",
                  "filterByUserId"
                ],
                "handle": "connection",
                "key": "PointsAdditionsTable_GetFilteredPointsAdditions",
                "kind": "LinkedHandle",
                "name": "GetFilteredPointsAdditions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "949e5bdc5ea98f7fee09766077ba6255",
    "id": null,
    "metadata": {},
    "name": "PointsAdditionsTable_Query",
    "operationKind": "query",
    "text": "query PointsAdditionsTable_Query(\n  $first: Int\n  $filterByPointsPoolId: ID\n  $filterByUserId: ID\n) {\n  ...PointsAdditionsTable_QueryFragment_39eEGx\n}\n\nfragment ContentNodeTitleColumn_PointsAdditionFragment on PointsAdditionV2 {\n  contentSubmission {\n    learnOpportunity {\n      structureDefinition {\n        __typename\n        title\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment PointsAdditionsTable_PointsAdditionFragment on PointsAdditionV2 {\n  ...ContentNodeTitleColumn_PointsAdditionFragment\n  ...PointsPoolColumn_PointsAdditionFragment\n  ...ReceivedAtColumn_PointsAdditionFragment\n  ...UserColumn_PointsAdditionFragment\n}\n\nfragment PointsAdditionsTable_QueryFragment_39eEGx on Query {\n  Admin {\n    PointsV2 {\n      GetFilteredPointsAdditions(first: $first, filterByPointsPoolId: $filterByPointsPoolId, filterByUserId: $filterByUserId) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            ...PointsAdditionsTable_PointsAdditionFragment\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment PointsPoolColumn_PointsAdditionFragment on PointsAdditionV2 {\n  pointsPool {\n    name\n    id\n  }\n}\n\nfragment ProjectUserDescription_UserFragment on User {\n  ...UserDescription_UserFragment\n}\n\nfragment ReceivedAtColumn_PointsAdditionFragment on PointsAdditionV2 {\n  receivedAt\n}\n\nfragment UserColumn_PointsAdditionFragment on PointsAdditionV2 {\n  user {\n    id\n    ...ProjectUserDescription_UserFragment\n  }\n}\n\nfragment UserDescription_UserFragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n      title\n      salutation\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab268949dfe5aa413093c841b0eca183";

export default node;
